import { API_URL } from "config";
import { OrderOptionsResponse, SearchOptionsResponseApi } from "features/order/types";
import Http from "util/https";

type Kind = 'shop' | 'vendor' | 'product';

/**
 * 仕入先選択肢取得Api
 * @returns レスポンスデータ
 */
export default async function getTyreOptionsApi(): Promise<OrderOptionsResponse> {
  let kind: Kind;
  if (localStorage.getItem('shop_cd')){
    kind = 'shop';
  } else if (localStorage.getItem('supplier_cd')) {
    kind = 'vendor';
  } else {
    kind = 'product';
  }
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/search/condition`;
  const res = await http.get<SearchOptionsResponseApi>(url);

  console.log(res);
  

  // const res: {data: SearchOptionsResponseApi} = {data: {
  //   tire_condition: {
  //     tire_width: [185,195],
  //     tire_ratio: [32,44],
  //     tire_rim_size: [15,16]
  //   },
  //   wheel_condition: {
  //     wheel_width: [5,5.5],
  //     wheel_pcd: [100.00,108.08],
  //     wheel_hole: [4,5],
  //     wheel_rim_size: [12.4,14]
  //   },
  //   classes: [{
  //     class_cd: "02",
  //     class_name: "タイヤ",
  //     vendors: [{
  //       vendor_cd: "0001",
  //       vendor_name: "ﾌﾞﾘﾁﾞｽﾄﾝ"
  //     }],
  //     subclasses: [{
  //       class_cd: "01",
  //       class_name: "中分類02_1"
  //     },{
  //       class_cd: "02",
  //       class_name: "中分類02_2"
  //     }]
  //   },{
  //     class_cd: "03",
  //     class_name: "ホイール",
  //     vendors: [{
  //       vendor_cd: "0001",
  //       vendor_name: "ﾌﾞﾘﾁﾞｽﾄﾝ"
  //     },{
  //       vendor_cd: "0002",
  //       vendor_name: "YOKOHAMA WHEEL"
  //     }],
  //     subclasses: [{
  //       class_cd: "01",
  //       class_name: "中分類03_1"
  //     },{
  //       class_cd: "02",
  //       class_name: "中分類03_2"
  //     },{
  //       class_cd: "03",
  //       class_name: "中分類03_3"
  //     },{
  //       class_cd: "04",
  //       class_name: "中分類03_4"
  //     },{
  //       class_cd: "05",
  //       class_name: "中分類03_5"
  //     },{
  //       class_cd: "06",
  //       class_name: "中分類03_6"
  //     },{
  //       class_cd: "07",
  //       class_name: "中分類03_7"
  //     },{
  //       class_cd: "08",
  //       class_name: "中分類03_8"
  //     },{
  //       class_cd: "09",
  //       class_name: "中分類03_9"
  //     }]
  //   },{
  //     class_cd: "04",
  //     class_name: "A・V・C",
  //     vendors: [{
  //       vendor_cd: "0003",
  //       vendor_name: "ﾕﾋﾟﾃﾙ"
  //     }],
  //     subclasses: [{
  //       class_cd: "01",
  //       class_name: "中分類04_1"
  //     },{
  //       class_cd: "02",
  //       class_name: "中分類04_2"
  //     },{
  //       class_cd: "03",
  //       class_name: "中分類04_3"
  //     },{
  //       class_cd: "04",
  //       class_name: "中分類04_4"
  //     },{
  //       class_cd: "05",
  //       class_name: "中分類04_5"
  //     },{
  //       class_cd: "06",
  //       class_name: "中分類04_6"
  //     },{
  //       class_cd: "07",
  //       class_name: "中分類04_7"
  //     },{
  //       class_cd: "08",
  //       class_name: "中分類04_8"
  //     },{
  //       class_cd: "09",
  //       class_name: "中分類04_9"
  //     }]
  //   }],
  //   brands: [{
  //     brand_code: "01",
  //     brand_name: "ブランド1",
  //   }, {
  //     brand_code: "02",
  //     brand_name: "ブランド2",
  //   }],
  //   status: [{
  //     status_code: "0",
  //     status_name: "未発注",
  //   },{
  //     status_code: "1",
  //     status_name: "確認中",
  //   },{
  //     status_code: "2",
  //     status_name: "発注待ち",
  //   },{
  //     status_code: "3",
  //     status_name: "発注済",
  //   },{
  //     status_code: "4",
  //     status_name: "出荷済",
  //   },{
  //     status_code: "5",
  //     status_name: "入荷待ち",
  //   },{
  //     status_code: "9",
  //     status_name: "欠品",
  //   }],
  // }};

  const options: OrderOptionsResponse = {
    classificationOptions: res.data.classes.map((c) => ({
      id: c.class_cd ?? '',
      name: c.class_name ?? '',
      category: (c.class_cd === '02' || c.class_cd === '03') ? 'tyre_wheel' : 'general',
      subclass: c.subclasses.map((sc) => ({
        subclassCd: sc.class_cd ?? '',
        subclassName: sc.class_name ?? '',
      })),
      suppliers: c.vendors.map(v => ({
        supplierCd: v.vendor_cd ?? '',
        supplierName: v.vendor_name ?? '',
      }))
    })),
    brandOptions: res.data.brands.map(b => b.brand_name ?? ''),
    tyreOptions: {
      tyreWidthList: res.data.tire_condition.tire_width ?? [],
      tyreRatioList: res.data.tire_condition.tire_ratio ?? [],
      tyreRimDiamList: res.data.tire_condition.tire_rim_size ?? [],
    },
    wheelOptions: {
      wheelWidthList: res.data.wheel_condition.wheel_width ?? [],
      wheelPcdList: res.data.wheel_condition.wheel_pcd ?? [],
      wheelHoleList: res.data.wheel_condition.wheel_hole ?? [],
      wheelRimDiamList: res.data.wheel_condition.wheel_rim_size ?? [],
    },
    statusOptions: res.data.status.map(s => ({
      statusCd: s.status_code ?? '',
      statusName: s.status_name ?? '',
    }))
  };

  return options;
}
